import React, { PureComponent } from 'react';
import ImageZoom from '../ImageContainer/ImageZoomWithCarousel/ImageZoom';
import './ProductImageWrapper.scss';
import ProductImagesList from '../ProductImagesList';
import './ImageZoomWithCarousel/ImageZoom.scss';
import LKModal from '../../Modal/Modal';
import { connect } from 'react-redux';

class ProductImageWrapper extends PureComponent {
  static propTypes = {};
  constructor(props) {
    super(props);
    // Product data from parent props
    this.resultData = props.productData.result;
    // Checks if current product data has imageUrlDetail
    this.hasImageDetails = this.resultData.imageUrlsDetail ? this.resultData.imageUrlsDetail : [];
    // If 'Image_Front' lable is not set then setting one
    this.isImageFrontAvailable = this.hasImageDetails.some(
      imgObj => imgObj.label === 'Image_Front'
    );
    if (!this.isImageFrontAvailable) {
      if (this.hasImageDetails && this.hasImageDetails[0]?.label) {
        this.hasImageDetails[0].label = 'Image_Front';
      }
    }
    // Regex to check and update diffrent image path with image object created for zoom container
    this.RegExLargeProductImg = /(thumbnail\/628x301\/)[a-zA-Z0-9]{32}/gm;
    // Empty object, expects data for first image on zoom container
    this.zoomSectionFrontImage = {};
    // Main image container width which will be overidden as per screen size in DIDMOUNT
    this.zoomContainerWidth = 800;
    // Default imageProps to be passed for react-imaeg-zoom
    this.imageZoomDefaultProps = {
      scale: 0.3,
      zoomWidth: 300,
      zoomStyle:
        'border: 1px solid rgb(0, 0, 0);background-color: white;cursor: pointer;z-index: 9;width: 350px;height: 350px;',
      zoomLensStyle:
        'border: 1px solid rgb(136, 136, 136);background-repeat: no-repeat;background-color: white;z-index: 10;opacity:0.3',
      offset: { vertical: 10, horizontal: 10 },
    };
    // Below function checks if current product object has imageUrlDetails then
    // below function fill "this.zoomSectionFrontImage" with front image detail and
    // it also creates data inside "this.processedImgObj" with "this.imageZoomDefaultProps" and imageUrlDetails
    // then it passes first image value in state to render the zoom container
    if (this.hasImageDetails) {
      this.processedImgObj = this.hasImageDetails.map((data, index) => {
        if (data.label === 'Image_Front') {
          this.zoomSectionFrontImage = this.updateImageObject(data, index);
        }
        return this.updateImageObject(data, index);
      });
      this.state = {
        zoomProps: null,
        modalImageIndex: 0, // Default index of image opening in modal which will be overitten later as per user interaction
        hoverImageLoaded: true, // this state makes the state true when user hovered thumbnail parent images is loaded
        showProductCarousel: false,
        show360View: false,
        threeSixtyIndex: 1,
      };
    }
  }

  componentDidMount = () => {
    // Check if user window size is lesser then update the "this.imageZoomDefaultProps" width property so that zoom lens works fine
    this.zoomContainerWidth = window.innerWidth * 0.75;
    if (this.zoomContainerWidth < 856) this.setZoomImageWidth(this.zoomContainerWidth);
    // const img = document.getElementsByClassName('image-zoom')[0].getElementsByTagName('img')[0];
    (() => {
      this.setState({ zoomProps: this.getFirstImage() });
    })();
  };

  componentDidUpdate(prevProps) {
    // When proudct change then update the "this.processedImgObj" with new data and "this.zoomSectionFrontImage" with new front image object
    if (prevProps.productID !== this.props.productID) {
      this.resultData = this.props.productData.result;
      this.hasImageDetails = this.resultData.imageUrlsDetail ? this.resultData.imageUrlsDetail : [];
      if (this.hasImageDetails) {
        this.processedImgObj = this.hasImageDetails.map((data, index) => {
          if (data.label === 'Image_Front') {
            this.zoomSectionFrontImage = this.updateImageObject(data, index);
          }
          return this.updateImageObject(data, index);
        });
      }
    }
  }

  setZoomImageWidth($winWidthCustomized) {
    this.zoomSectionFrontImage = Object.assign(
      {},
      this.zoomSectionFrontImage,
      { width: $winWidthCustomized },
      { img: this.zoomSectionFrontImage.mediumImg }
    );
    this.setState({ zoomProps: this.zoomSectionFrontImage, hoverImageLoaded: true }, () => {});
  }

  // Gets first image for current product component
  getFirstImage() {
    if ('img' in this.zoomSectionFrontImage) {
      this.setState({ modalImageIndex: this.zoomSectionFrontImage.index });
      return Object.assign({}, this.zoomSectionFrontImage, {
        img: this.zoomSectionFrontImage.mediumImg,
      });
    }
    this.setState({ modalImageIndex: this.processedImgObj[0].index });
    return Object.assign({}, this.processedImgObj[0], {
      img: this.processedImgObj[0].mediumImg,
    });
  }

  // It sets updated props whenever user hover over the thumbnails
  setZoomProps = props => {
    const zoomImageProps = Object.assign({}, props, {
      img: props.mediumImg,
      width:
        this.zoomContainerWidth < 856 ? this.zoomContainerWidth : this.imageZoomDefaultProps.width,
    });
    this.setState(
      {
        hoverImageLoaded: false,
      },
      () => {
        this.loadImage(zoomImageProps, []);
      }
    );
  };

  // It changes z-index of 360 degree view button
  update360ZIndex = value => {
    this.setState({ threeSixtyIndex: value });
  };

  // Utility function to call image on demand
  loadImage = (zoomImageProps, imgArr) => {
    const imgArray = new Array(imgArr.length);
    if (imgArr.length) {
      for (let i = 0; i < imgArr.length; i += 1) {
        imgArray[i] = new Image();
        imgArray[i].src = imgArr[i];
      }
    } else {
      imgArray[0] = new Image();
      imgArray[0].src = zoomImageProps.mediumImg;
      imgArray[0].onload = () => {
        this.setState({
          zoomProps: zoomImageProps,
          modalImageIndex: zoomImageProps.index,
          hoverImageLoaded: true,
        });
      };
    }
  };

  updateImageObject(data, index) {
    return Object.assign(
      {},
      {
        img: data.url,
      },
      {
        smImg: data.url.replace(this.RegExLargeProductImg, this.resultData.imageResolutions[0]),
      },
      {
        mediumImg: data.url.replace(this.RegExLargeProductImg, this.resultData.imageResolutions[3]),
      },
      data,
      {
        index,
      },
      this.imageZoomDefaultProps
    );
  }

  openCarouselModal = value => {
    if (this.processedImgObj.length - 1 >= value) {
      const zoomProps = { ...this.processedImgObj[value] };
      zoomProps.img = zoomProps.mediumImg;
      this.setState({ modalImageIndex: value, zoomProps, showProductCarousel: true });
    }
  };
  show360View(type) {
    this.setState({ show360View: type });
  }

  render() {
    const { imageUrlsDetail, imageUrls, threeSixtyViewStatus, productID, dataLocale } = this.props;
    const {
      zoomProps,
      modalImageIndex,
      hoverImageLoaded,
      showProductCarousel,
      show360View,
      threeSixtyIndex,
    } = this.state;
    const { android_active } = threeSixtyViewStatus || {};
    return (
      <>
        <div className={`product-image mr-b20 pos-rel ${imageUrls ? '' : 'prod-img-container'}`}>
          {Boolean(android_active) && android_active === 1 && (
            <React.Fragment>
              <div
                className="view-360 pos-abs"
                style={{ zIndex: threeSixtyIndex }}
                onClick={() => this.show360View(true)}
              >
                <img
                  alt="View #60"
                  src="https://static.lenskart.com/media/desktop/img/view-360.svg"
                />
              </div>
              {show360View && (
                <LKModal
                  backdrop
                  keyboard
                  className="pos-rel"
                  dialogClassName="container-view-360"
                  hideHandler={() => this.show360View(false)}
                  showModal={show360View}
                >
                  <span className="modal-close-360" onClick={() => this.show360View(false)}>
                    ×
                  </span>
                  <iframe
                    src={`https://arsdk.lookr.in/frontend/gltfviewer?sku=${productID}`}
                    title="lenskart"
                  ></iframe>
                </LKModal>
              )}
            </React.Fragment>
          )}
          <ProductImagesList
            android_active={android_active}
            dataLocale={dataLocale}
            imageUrlsDetail={imageUrlsDetail}
            list={imageUrls}
            openCarouselModal={value => this.openCarouselModal(value)}
            update360ZIndex={value => this.update360ZIndex(value)}
          />
          {this.hasImageDetails && showProductCarousel && zoomProps && (
            <div className="image-with-zoom image-container">
              <ImageZoom
                changeCarouselSlide={value => this.openCarouselModal(value)}
                hideModal={() => this.setState({ showProductCarousel: false })}
                hoverImageLoaded={hoverImageLoaded}
                loadImage={this.loadImage}
                modalImageIndex={modalImageIndex}
                processedImage={this.processedImgObj}
                zoomProps={zoomProps}
                zoomSectionFrontImage={this.zoomSectionFrontImage}
                {...this.props}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
  };
};

export default connect(mapStateToProps, null)(ProductImageWrapper);
